/* eslint-disable react-hooks/exhaustive-deps */
import { BaseOptionType } from 'rc-select/lib/Select'
import { useMemo } from 'react'

import { useUser } from '../../contexts'
import { BlocktrainDetail, Depot } from '../../types'

const useOrigins = (blocktrain?: BlocktrainDetail) => {
  const { state: user } = useUser()

  const origins: Depot[] = useMemo(
    () => [
      ...(!!user?.userDetail.supplier?.depots?.length ? user.userDetail.supplier.depots : []),
      ...(!!blocktrain?.origin ? [blocktrain.origin] : []),
    ],
    [blocktrain, user],
  )

  const originOptions = useMemo(
    () =>
      origins.reduce((acc: BaseOptionType[], origin: Depot) => {
        if (!acc.some(item => item.value === origin.id)) {
          acc.push({
            label: origin.tag,
            value: origin.id,
          })
        }
        return acc
      }, []),
    [origins],
  )

  return originOptions ?? []
}

export default useOrigins
